viewportAnimation();
jQuery(document).scroll(function(){
  viewportAnimation();
})

function viewportAnimation() {
  jQuery('.with-fade-anim:in-viewport').each(function(){
    var $this = jQuery(this);
    if (!$this.hasClass('fadeInCustom')){
      setTimeout(function(){
        $this.addClass('fadeInCustom');
      }, 300);
    }
  });
}